import { render, staticRenderFns } from "./newXieTongDetails.vue?vue&type=template&id=5efcf230&scoped=true"
import script from "./newXieTongDetails.vue?vue&type=script&lang=js"
export * from "./newXieTongDetails.vue?vue&type=script&lang=js"
import style0 from "./newXieTongDetails.vue?vue&type=style&index=0&id=5efcf230&prod&scoped=true&lang=scss"
import style1 from "./newXieTongDetails.vue?vue&type=style&index=1&id=5efcf230&prod&lang=css"
import style2 from "./newXieTongDetails.vue?vue&type=style&index=2&id=5efcf230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efcf230",
  null
  
)

export default component.exports